<template>
  <div class="layout">
    <Row>
      <Col span='24'>
      <h1 class='title' style="font-size: 16px;">
        <strong>{{this.$t('performanceQueryPoints.perfDemePoints')}}</strong><!-- 扣分项查询 -->
      </h1>
      </Col>
    </Row>
    <Row>
      <Col span='24'>
      <page-form :formData="formData" ref="formDataName" @onSubmit="reSearch" :needValidation="true"></page-form>
      </Col>
    </Row>
    <Row style="margin-bottom:10px;">
      <m-button type="primary" @click="exportExcel" :disabled="resultSource.total==0">{{this.$t('common.export')}}</m-button><!-- 导出 -->
    </Row>
    <Table border ref="tableId" :columns="tableColumns" :data="resultSource.list"></Table>
    <pagination :currentPage="page" :total="resultSource.total" size="small" style="padding-top:15px" :pageSize="pageSize" show-elevator show-sizer @on-current-page-change="onPageChange" @on-page-size-change="onPageSizeChange" placement="top"></pagination>
    <Row>
      <Col span='24' style="text-align:center">
      <m-button type="primary" @click="goBack" style="margin-left:20px">{{this.$t('common.back')}}</m-button><!-- 返回 -->
      </Col>
    </Row>
  </div>
</template>
<script>
  import PageForm from '@/components/awesome/page/query/index';
  import pagination from '@/components/awesome/page/pagination/index';
  import httpservice from '../../../../utils/http';
  import {formatDateTime} from '@/utils/datetime-format.js';
  import axios from 'axios';

  export default {
    name: 'PerformanceQueryPoints',
    components: {
      PageForm,
      pagination
    },
    data() {
      return {
        currLang: this.$i18n.locale,
        page: 1,
        pageSize: 10,
        loading: false,
        vendorCode: '',
        fromObj: {},
        queryParam: '',
        indicatorResult: {},
        formData: {
          row: 7,
          items: [
            {
              title: this.$t('performanceQueryPoints.organization'), // 库存组织
              value: '',
              field: 'organizationCode',
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {
                change() {
                }
              },
              options: {
                multiple: false,
                values: []
              },
              type: 'select'
            },
            {
              title: this.$t('performanceQueryPoints.indexName'), // 指标名称
              value: '',
              field: 'indicatorName',
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {
                change() {
                }
              },
              options: {
                multiple: false,
                values: []
              },
              // validators: {
              //     required: {
              //         required: true,
              //         message: '必填'
              //     }
              // },
              type: 'select'
            },
            {
              title: this.$t('performanceQueryPoints.category'), // 采购分类
              value: '',
              field: 'categoryCode',
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {
                changed: (item) => {
                }
              },
              options: {
                rows: 1
              },
              type: 'text'
            },
            {
              title: this.$t('performanceQueryPoints.perfMouthFrom'), // 绩效月份从
              value: '',
              field: 'startMonth',
              layout: {
                span: 8,
                offset: 0,
                row: 2
              },
              methods: {},
              options: {
                type: 'month',
                format: 'yyyy-MM'
              },
              style: 'width:100%',
              type: 'datePicker',
              isDouble: true
            },
            {
              title: this.$t('performanceQueryPoints.to'), // 至
              hide: true,
              value: '',
              field: 'endMonth',
              layout: {
                span: 8,
                offset: 0,
                row: 2
              },
              methods: {},
              options: {
                type: 'month',
                format: 'yyyy-MM'
              },
              style: 'width:100%',
              type: 'datePicker'
            },
            {
              title: this.$t('performanceQueryPoints.cateEvalClass'), // 品类评价分类
              value: '',
              field: 'qualityEvaCat',
              layout: {
                span: 8,
                offset: 0,
                row: 2
              },
              methods: {
                changed: (item) => {
                }
              },
              options: {
                rows: 1
              },
              type: 'text'
            }
          ]
        },
        tableColumns: [
          {
            title: this.$t('performanceQueryPoints.performanceMouth'), // 绩效月份
            key: 'perfMonth',
            align: 'center',
            minWidth: 70
          },
          {
            title: this.$t('performanceQueryPoints.indexName'), // 指标名称
            key: 'indicatorName',
            minWidth: 100
          },
          {
            title: this.$t('performanceQueryPoints.organization'), // 库存组织
            key: 'organizationName',
            minWidth: 200,
            render: (h, params) => {
              if (params.row.organizationName) {
                return h('Tooltip', {
                  props: {
                    content: params.row.organizationName.split('INV_')[1],
                    placement: 'top'
                  },
                  class: 'm-tooltip-overflow'
                }, params.row.organizationName.split('INV_')[1]);
              }
            }
          },
          {
            title: this.$t('performanceQueryPoints.materialCode'), // 物料编码
            key: 'itemCode',
            minWidth: 120
          },
          {
            title: this.$t('performanceQueryPoints.categoryCode'), // 小类编码
            key: 'categoryCode',
            minWidth: 110
          },
          {
            title: this.$t('performanceQueryPoints.cateEvalClass'), // 品质评价分类
            key: 'qualityCategoryName',
            minWidth: 110
          },
          {
            title: this.$t('performanceQueryPoints.unqualifiedType'), // 不合格类型
            key: 'unqualifiedType',
            minWidth: 110
          },
          {
            title: this.$t('performanceQueryPoints.cemeritPoints'), // 扣分
            key: 'score',
            align: 'center',
            minWidth: 40
          },
          {
            title: this.$t('performanceQueryPoints.Remark'), // 备注
            key: 'remark',
            minWidth: 110,
            render: (h, params) => {
              if (params.row.remark) {
                return h('Tooltip', {
                  props: {
                    content: params.row.remark,
                    placement: 'top'
                  },
                  class: 'm-tooltip-overflow'
                }, params.row.remark);
              }
            }
          },
          {
            title: this.$t('performanceQueryPoints.attachment'), // 附件
            key: 'fileName',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      console.log('url');
                    }
                  }
                }, params.row.fileName)
              ]);
            },
            minWidth: 110
          }
        ],
        resultSource: {total: 0, list: []},
        result: {},
        orgResult: [
          {value: '', label: ''} // total,INV_M40_水壶及料理电器制造库存组织
        ]
      };
    },
    watch: {
      'result': function () {
        this.resultSource = this.result;
      },
      'orgResult': function () {
        this.formData.items[0].options.values = this.orgResult;
        this.formData.items[0].value = this.fromObj.organizationCode;
      },
    },
    methods: {
      goBack() {
        this.$router.push({path: '/performance/performanceQueryView'});
      },
      reSearch() {
        this.page = 1;
        this.onSearch();
      },
      onSearch() {
        let params = {};
        this.formData.items.map((item) => {
            if (item.type === 'datePicker') {
              if (item.field === 'startMonth') {
                params.startMonth = item.value ? formatDateTime(new Date(item.value), 'yyyyMM') : '';
              } else {
                params.endMonth = item.value ? formatDateTime(new Date(item.value), 'yyyyMM') : '';
              }
            } else {
                params[item.field] = item.value;
            }
        });
        params.language = this.currLang;
        params.vendorCode = this.vendorCode;
        params.pageNum = this.page;
        params.pageSize = this.pageSize;
        this.loading = true;
        this.result = {};
        httpservice.post('/srmperf/gsc/composite/queryIndicatorScore', params).then(res => {
            try {
                this.loading = false;
                const { status, data, msg: content } = res.data;
                if (status === 0) {
                    this.result = data;
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content,
                    });
                }
            } catch (err) {
                console.log('err:', err);
            }
        }).catch(() => {
            this.loading = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1')
            });
        });
      },
      onPageChange(page) {
        this.page = page;
        this.onSearch();
      },
      onPageSizeChange(pageSize) {
        this.pageSize = pageSize;
        this.onSearch();
      },
      getDict() {
        httpservice.get('/gscint/vendor/getInvLovTwo?UP=Y&SITE=Y&ASL=Y&labelName=organizationName&valueName=organizationCode').then(res => {
          this.orgResult = res.data.data;
        });
        const dictUrl = `/srmbase/pos/queryDictionaryLine?showExpiratedItem=N&entryLanguage=${this.$i18n.locale === 'zh-CN' ? 'zh-CN' : 'us'}`;
        // httpservice.get('/gscapp/performance/getType').then(res => {
        //     this.indicatorResult = res.data;
        // });
        axios.all([axios.get(`${dictUrl}&dictionaryCode=CUX_PEF_INDICATOR&entryFlag=QUALITY`), axios.get(`${dictUrl}&dictionaryCode=CUX_PEF_INDICATOR&entryFlag=BUSINESS&entryCode=ABNORMAL_SUPPLY`)])
            .then((res) => {
                const [data1, data2] = res;
                this.getFormDataItemObj(this.formData.items, 'indicatorName').options.values = (data1.data.data.data || []).concat(data2.data.data.data || []);
            });
      },
      exportExcel() {
        var a = document.createElement('a');
        let params = {};
        this.formData.items.map((item) => {
            if (item.type === 'datePicker') {
              if (item.field === 'startMonth') {
                params.startMonth = item.value ? formatDateTime(new Date(item.value), 'yyyyMM') : '';
              } else {
                params.endMonth = item.value ? formatDateTime(new Date(item.value), 'yyyyMM') : '';
              }
            } else {
                params[item.field] = item.value;
            }
        });
        params.language = this.currLang;
        params.vendorCode = this.vendorCode;
        params.pageNum = this.page;
        params.pageSize = this.pageSize;
        console.log('JSON.stringify(params::', JSON.stringify(params));

        a.href = '/srmperf/gsc/composite/exportIndicatorScore?paraJson=' + encodeURI(JSON.stringify(params));
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    },
    mounted() {
      this.vendorCode = JSON.parse(localStorage.getItem('supplierInfo')).vendorCode;
      this.fromObj = JSON.parse(this.$route.query.row);
      let month = this.fromObj.perfMonth;
      this.fromObj.perfMonth = month ? month.substring(0, 4) + '-' + month.substring(4, 6) : '';
      this.formData.items[0].value = this.fromObj.organizationCode;
      this.formData.items[2].value = this.fromObj.categoryCode;
      this.formData.items[3].value = this.fromObj.perfMonth; // 2019-09
      this.formData.items[4].value = this.fromObj.perfMonth;
      this.getDict();
    }
  };
</script>

<style scoped lang='less'>
  .layout {
    padding: 20px;
    height: 100%;
    background-color: #fff;
    .title {
      margin-bottom: 30px;
    }
  }
</style>
